export type LightingModeIconId =
  | "waveHorizontal"
  | "waveVertical"
  | "spreadCenter"
  | "starTwinkle"
  | "breathing"
  | "spectrumCycle"
  | "disco"
  | "staticOn"
  | "linearGradient"
  | "verticalLift"
  | "bounceBack"
  | "whirlCenter"
  | "diagonalStream"
  | "laserRain"
  | "sparkTwinkle"
  | "fireworks"
  | "triangleBounce"
  | "staticRipple"
  | "keyRipple"
  | "keyTrail"
  | "keyFireworks"
  | "keyLightColumn"
  | "off"
  | "keyPressOn"
  | "keyReleaseOff"
  | "snow"
  | "blossom"
  | "spring"
  | "colorfulGrid"
  | "peakTurn"
  | "instant"
  | "doubleHit"
  | "ripple"
  | "flow"
  | "mountain"
  | "shuttle"
  | "heartbeat"
  | "custom"
  | "neon"
  | "colorfulCloud"
  | "flying"
  | "traverse"
  | "scan"
  | "scanHorizontal"
  | "tide"
  | "rainbow"
  | "swirl"
  | "glow"
  | "pane"
  | "sineWave"
  | "mosaic"
  | "rain"
  | "morph"
  | "waterRipple"
  | "shadow"
  | "meteor"
  | "train"
  | "chasing"
  | "shrink"
  | "marquee"
  | "crossLight"
  | "singleOn"
  | "circles"
  | "rowLight"
  | "centerCollision"
  | "windmill"
  | "waterfall"
  | "dreamRainbow"
  | "stormSpin"
  | "rippleWave"
  | "starField"
  | "snowFall"
  | "footprintSnow"
  | "sparkleArc";

export type LightingIconProvider =
  | "zhwx"
  | "huafenda"
  | "xingshan"
  | "rongyuan"
  | "beiying"
  | "sdcx";

export type LightingIconArea = "Keyboard" | "Decorate1";

const ZHWX: Record<number, LightingModeIconId> = {
  0: "waveHorizontal",
  1: "colorfulCloud",
  2: "neon",
  3: "whirlCenter",
  4: "blossom",
  5: "flying",
  6: "traverse",
  7: "rain",
  8: "spectrumCycle",
  9: "breathing",
  10: "staticOn",
  11: "keyRipple",
  12: "laserRain",
  13: "sparkTwinkle",
  14: "spreadCenter",
  15: "scan",
  16: "linearGradient",
  17: "custom",
};

const HFD: Record<number, LightingModeIconId> = {
  9999: "off",
  1: "staticOn",
  2: "keyPressOn",
  3: "keyReleaseOff",
  4: "starField",
  5: "snowFall",
  6: "blossom",
  7: "breathing",
  8: "spectrumCycle",
  9: "spring",
  10: "colorfulGrid",
  11: "waveHorizontal",
  12: "peakTurn",
  13: "instant",
  14: "doubleHit",
  15: "ripple",
  16: "flow",
  17: "mountain",
  18: "rain",
  19: "shuttle",
  254: "heartbeat",
  20: "custom",
};

const HFD_LIGHT_BOX: Record<number, LightingModeIconId> = {
  5: "off",
  1: "diagonalStream",
  2: "staticOn",
  3: "breathing",
  4: "spectrumCycle",
};

const XINGSHAN: Record<number, LightingModeIconId> = {
  0: "staticOn",
  1: "waveHorizontal",
  2: "tide",
  3: "ripple",
  4: "stormSpin",
  5: "rainbow",
  6: "swirl",
  7: "sparkleArc",
  8: "glow",
  9: "pane",
  10: "flow",
  11: "sineWave",
  12: "mosaic",
  13: "blossom",
  14: "rain",
  15: "morph",
  17: "footprintSnow",
  18: "laserRain",
  19: "waterRipple",
};

const RONGYUAN_KEYBOARD: Record<number, LightingModeIconId> = {
  0x04: "waveHorizontal",
  0x05: "rippleWave",
  0x06: "starField",
  0x07: "flow",
  0x08: "shadow",
  0x09: "mountain",
  0x0a: "sineWave",
  0x0b: "spring",
  0x0c: "blossom",
  0x13: "footprintSnow",
  0x0e: "doubleHit",
  0x0f: "peakTurn",
  0x10: "colorfulGrid",
  0x11: "snowFall",
  0x12: "meteor",
  0x01: "staticOn",
  0x02: "breathing",
  0x03: "spectrumCycle",
  0x17: "train",
  0x80: "custom",
};

const RONGYUAN_DECORATE: Record<number, LightingModeIconId> = {
  9999: "off",
  0x04: "waveVertical",
  0x05: "shuttle",
  0x01: "staticOn",
  0x02: "breathing",
  0x03: "neon",
};

const BEIYING_KEYBOARD: Record<number, LightingModeIconId> = {
  0: "off",
  1: "staticOn",
  2: "breathing",
  3: "dreamRainbow",
  4: "instant",
  5: "rain",
  6: "rainbow",
  7: "ripple",
  8: "starField",
  9: "footprintSnow",
  10: "flow",
  11: "waveHorizontal",
  12: "shadow",
  13: "sineWave",
  14: "scanHorizontal",
  15: "windmill",
  16: "waterfall",
  17: "blossom",
  18: "stormSpin",
  19: "custom",
};

const BEIYING_STRIP: Record<number, LightingModeIconId> = {
  0: "off",
  1: "flow",
  2: "dreamRainbow",
  3: "staticOn",
  4: "breathing",
  5: "marquee",
};

const SDCX: Record<number, LightingModeIconId> = {
  1: "staticOn",
  2: "breathing",
  3: "waveHorizontal",
  4: "spreadCenter",
  5: "diagonalStream",
  6: "keyReleaseOff",
  7: "chasing",
  8: "shrink",
  9: "marquee",
  10: "rowLight",
  11: "shuttle",
  12: "rain",
  13: "crossLight",
  14: "singleOn",
  15: "diagonalStream",
  16: "circles",
  17: "staticRipple",
  18: "scan",
  19: "sparkTwinkle",
  20: "waterRipple",
  21: "rowLight",
  22: "waveVertical",
  23: "centerCollision",
};

/** i18n key 末段 → icon（兜底） */
const I18N_SUFFIX_ICON: Record<string, LightingModeIconId> = {
  static: "staticOn",
  wave: "waveHorizontal",
  tide: "tide",
  ripple: "ripple",
  ripple2: "rippleWave",
  storm: "stormSpin",
  rainbow: "rainbow",
  swirl: "swirl",
  sparkle: "sparkleArc",
  starry: "starField",
  snowFly: "snowFall",
  glow: "glow",
  pane: "pane",
  flow: "flow",
  sine: "sineWave",
  mosaic: "mosaic",
  blossom: "blossom",
  rain: "rain",
  morph: "morph",
  snow: "snow",
  snowTrail: "footprintSnow",
  laser: "laserRain",
  waterRipple: "waterRipple",
  off: "off",
  custom: "custom",
  breathing: "breathing",
  spectrum: "spectrumCycle",
  colorfulCloud: "colorfulCloud",
  neon: "neon",
  whirl: "whirlCenter",
  flying: "flying",
  traverse: "traverse",
  singlePoint: "sparkTwinkle",
  spread: "spreadCenter",
  scan: "scan",
  lightWave: "sineWave",
  gradient: "linearGradient",
  flowingLight: "diagonalStream",
  staticConstantBrightness: "staticOn",
  dynamicBreathing: "breathing",
  spectralCycle: "spectrumCycle",
  waveRight: "waveHorizontal",
  waveLeft: "waveVertical",
  diagonalWave: "diagonalStream",
  rippleOff: "keyReleaseOff",
  rippleOn: "staticRipple",
  chasing: "chasing",
  shrink: "shrink",
  marquee: "marquee",
  rowPressOff: "keyReleaseOff",
  raindrops: "rain",
  crossLight: "crossLight",
  singleOn: "singleOn",
  diagonalCut: "diagonalStream",
  circles: "circles",
  slantedSweep: "scan",
  singleOff: "sparkTwinkle",
  waterTrace: "waterRipple",
  rowLight: "rowLight",
  centerCollision: "centerCollision",
  pressLight: "keyPressOn",
  releaseOff: "keyReleaseOff",
  doubleHit: "doubleHit",
  peakTurn: "peakTurn",
  instant: "instant",
  mountain: "mountain",
  shuttle: "shuttle",
  heartbeat: "heartbeat",
  colorful: "colorfulGrid",
  spring: "spring",
  flowExtend: "diagonalStream",
  meteor: "meteor",
  train: "train",
  shadow: "shadow",
  stripWave: "waveVertical",
  stripMarquee: "marquee",
  stripStatic: "staticOn",
  stripBreathing: "breathing",
  stripNeon: "neon",
};

function iconFromLabelKey(labelKey?: string): LightingModeIconId | undefined {
  if (!labelKey) return undefined;
  const suffix = labelKey.split(".").pop();
  if (!suffix) return undefined;
  return I18N_SUFFIX_ICON[suffix];
}

export function resolveLightingModeIconId(
  provider: LightingIconProvider,
  mode: number,
  opts?: { labelKey?: string; area?: LightingIconArea }
): LightingModeIconId {
  const area = opts?.area ?? "Keyboard";
  let mapped: LightingModeIconId | undefined;

  switch (provider) {
    case "zhwx":
      mapped = ZHWX[mode];
      break;
    case "huafenda":
      mapped = area === "Decorate1" ? HFD_LIGHT_BOX[mode] : HFD[mode];
      break;
    case "xingshan":
      mapped = XINGSHAN[mode];
      break;
    case "rongyuan":
      mapped =
        area === "Decorate1"
          ? RONGYUAN_DECORATE[mode]
          : RONGYUAN_KEYBOARD[mode];
      break;
    case "beiying":
      mapped =
        area === "Decorate1" ? BEIYING_STRIP[mode] : BEIYING_KEYBOARD[mode];
      break;
    case "sdcx":
      mapped = SDCX[mode];
      break;
    default:
      break;
  }

  if (mapped) return mapped;
  return iconFromLabelKey(opts?.labelKey) ?? "staticOn";
}

/** ButtonGroup 左图标 + 右文案布局 */
export const LIGHTING_MODE_BUTTON_GROUP_CLASS =
  "lighting-mode-button-group--with-icon";
